import api from './api'

const API = '/api/barangays'

export const Barangay = {
 
  get: function(params) {
    return api.get(API, {params: params})
  },
  show: function(id, params) {
    return api.get(API + '/' + id, params)
  },
  downloadQr: function(id, params) {
    return api.get(API + '/' + id +'/download-qr', params)
  },
  exportExcel: function(id, params) {
    return api.get(API + '/' + id +'/export-excel', params)
  },
  leaders: function(id, params) {
    return api.get(API + '/' + id + '/leaders', {params: params})
  },
  create: function(form) {
    return api.create(API, form)
  },
  update: function(id,form) {
    return api.update(API+'/'+id, form)
  },
  delete: function(id) {
    return api.delete(API+'/'+id)
  },
  removeVoterActions: function(id) {
    return api.delete(API+'/'+id+'/remove-voter-actions')
  },
}
